import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../Common/Configurations/AuthContext"; // Adjust path if needed
import DefaultData from "../../CompanyData/DefaultData"; // Adjust path if needed

const MasterTabs = (props) => {
  const { user } = useAuth();
  
  // Check if company type is DMC
  const isDMCCompany = user?.companyType?.toLowerCase() === "dmc";
  
  const baseTabStyle = {
    border: "none",
    fontWeight: "500",
    padding: "0.75rem 1.5rem",
    borderRadius: "0.375rem 0.375rem 0 0",
  };
  const inactiveTabStyle = {
    ...baseTabStyle,
    backgroundColor: "transparent",
    color: DefaultData.THEMECOLOR3,
    opacity: 2,
  };
  const activeTabStyle = {
    ...baseTabStyle,
    backgroundColor: DefaultData.THEMECOLOR2,
    color: DefaultData.THEMECOLOR3,
  };
  const getStyle = (pageName) =>
    props.pageName === pageName ? activeTabStyle : inactiveTabStyle;

  return (
    <div
      style={{
        backgroundColor: DefaultData.THEMECOLOR5,
        padding: "0 1rem",
        borderBottom: `1px solid ${DefaultData.THEMECOLOR2}`,
      }}
    >
      <ul className="nav nav-tabs" style={{ borderBottom: "none" }}>
        <li className="nav-item" role="presentation">
          <Link
            to={"/companyprofile"}
            className="nav-link"
            style={getStyle("COMPANYPROFILE")}
          >
            PROFILE
          </Link>
        </li>
        <li className="nav-item" role="presentation">
          <Link to={"/branchs"} className="nav-link" style={getStyle("BRANCH")}>
            BRANCH
          </Link>
        </li>
        <li className="nav-item" role="presentation">
          <Link to={"/users"} className="nav-link" style={getStyle("USER")}>
            USERS
          </Link>
        </li>
        <li className="nav-item" role="presentation">
          <Link
            to={"/changepassword"}
            className="nav-link"
            style={getStyle("CHANGEPASSWORD")}
          >
            CHANGE PASSWORD
          </Link>
        </li>
        <li className="nav-item" role="presentation">
          <Link to={"/myplan"} className="nav-link" style={getStyle("MYPLAN")}>
            MY PLAN
          </Link>
        </li>
        {/* <li className="nav-item" role="presentation">
          <Link
            to={"/companybankaccounts"}
            className="nav-link"
            style={getStyle("COMPANYBANK")}
          >
            COMPANY BANKACCOUNTS
          </Link>
        </li> */}
       
        {/* Hide Employee tab for DMC companies */}
        {!isDMCCompany && (
          <li className="nav-item" role="presentation">
            <Link
              to={"/employee"}
              className="nav-link"
              style={getStyle("EMPLOYEE")}
            >
              EMPLOYEE
            </Link>
          </li>
        )}
      </ul>
    </div>
  );
};

export default MasterTabs;